import styled from "styled-components";

export const ImportWrapper = styled.div`
  display: flex;
  height: 100vh;
`;

export const Content = styled.div`
  flex: 1;
  padding: 20px;
  overflow-y: auto;
`;

export const Card = styled.div`
  background-color: transparent;
  margin: 20px 0;
  overflow: hidden;
`;

export const FileInput = styled.input`
  margin-top: 10px;
`;

export const ScrollableTableWrapper = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  border: 1px solid #ddd;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9f9f9;
  }
`;

export const TableCell = styled.td`
  padding: 8px;
  border: 1px solid #ddd;
`;

export const TableHeader = styled.th`
  padding: 8px;
  border: 1px solid #ddd;
  background-color: #f1f1f1;
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const Message = styled.div`
  color: ${({ $isError }) => ($isError ? "red" : "green")};
  font-size: 16px;
  margin-top: 10px;
`;

export const Button = styled.button`
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;

  &:hover {
    background-color: #0056b3;
  }
`;

export const TabButtons = styled.div`
  display: flex;
  background-color: #f1f1f1;
  border-bottom: 1px solid #ccc;
  justify-content: flex-start; /* Align tabs to the left */
  align-items: center; /* Align tabs vertically */
  width: 100%; /* Ensure it spans the full width */
  gap: 10px; /* Add space between tabs */
`;

export const TabButton = styled.button`
  padding: 5px 10px;
  text-align: center;
  font-size: 18px;
  font-family: "Segoe UI Light", "Segoe UI", sans-serif;
  font-weight: 300;
  font-weight: bold;
  border: none;
  cursor: pointer;
  background-color: ${({ $active }) => ($active ? "#ffffff" : "#f1f1f1")};
  color: ${({ $active }) => ($active ? "#007bff" : "#555")};
  border-bottom: ${({ $active }) => ($active ? "2px solid #007bff" : "none")};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0; /* Prevent shrinking */
  white-space: nowrap; /* Prevent text from wrapping */
  gap: 6px; /* Add space between icon and text */

  &:hover {
    background-color: ${({ $active }) => ($active ? "#ffffff" : "#eaeaea")};
  }

  svg {
    margin-right: 6px;
    font-size: 16px;
  }
`;



